import * as L from "lonna"
import * as uuid from "uuid"
import { Board } from "../../../common/src/domain"
import { Dispatch } from "../store/board-store"
import { BoardFocus, getSelectedItems } from "./board-focus"
import { installKeyboardShortcut } from "./keyboard-shortcuts"
import { canMove } from "./board-permissions"

// Cmd-G groups the selection (one shared groupId), Cmd-Shift-G ungroups. Flat groups: regrouping merges.
export function groupSelected(board: Board, focus: BoardFocus, dispatch: Dispatch) {
    const items = getSelectedItems(board)(focus).filter(canMove)
    if (items.length < 2) return
    const groupId = uuid.v4()
    dispatch({ action: "item.update", boardId: board.id, items: items.map((i) => ({ id: i.id, groupId })) })
}

export function ungroupSelected(board: Board, focus: BoardFocus, dispatch: Dispatch) {
    const items = getSelectedItems(board)(focus).filter((i) => i.groupId && canMove(i))
    if (!items.length) return
    dispatch({ action: "item.update", boardId: board.id, items: items.map((i) => ({ id: i.id, groupId: null })) })
}

export const isGrouped = (board: Board, focus: BoardFocus) => getSelectedItems(board)(focus).some((i) => !!i.groupId)

export function itemGroupHandler(board: L.Property<Board>, focus: L.Property<BoardFocus>, dispatch: Dispatch) {
    const cmd = (e: JSX.KeyboardEvent) => (e.metaKey || e.ctrlKey) && !e.altKey && e.key.toLowerCase() === "g"
    installKeyboardShortcut(
        (e) => cmd(e) && !e.shiftKey,
        () => groupSelected(board.get(), focus.get(), dispatch),
    )
    installKeyboardShortcut(
        (e) => cmd(e) && e.shiftKey,
        () => ungroupSelected(board.get(), focus.get(), dispatch),
    )
}
